import type { Path } from '@cobliteam/api-lib/src/__generated__/graphql';
import Typography from '@cobliteam/ui/components/Typography';
import Icon from '@cobliteam/ui/icons';
import type { DriverOption } from '@cobliteam/ui-business/components/Selects/SelectDriver/SelectDriver';
import { format } from '@cobliteam/utils/date';

interface DriverConfirmationSummaryProps {
  path: Path;
  newDriver?: DriverOption;
}

const DriverConfirmationSummary = ({ path, newDriver }: DriverConfirmationSummaryProps) => {
  const { startTime, endTime, driver, vehicle } = path;
  const { licensePlate, model } = vehicle || {};

  const startDate = format(startTime, 'dd/MM/yyyy, HH:mm');
  const endDate = format(endTime, 'HH:mm');

  const driverName = driver?.name || '';
  const newDriverName = newDriver?.name || 'Sem motorista';

  return (
    <>
      <div className='flex flex-col gap-2'>
        <div className='flex items-center gap-2'>
          <Icon name='car-front' />
          <Typography variant='body' color='secondary'>
            {licensePlate} - {model?.brand} {model?.name}
          </Typography>
        </div>
        <div className='flex items-center gap-2'>
          <Icon name='calendar-days' />
          <Typography variant='body' color='secondary'>
            {startDate} - {endDate}
          </Typography>
        </div>
      </div>

      <div className='flex flex-col gap-2'>
        <div className='flex items-center gap-2'>
          <Icon name='circle-user-round' />
          <Typography variant='description-title' color='secondary'>
            Novo motorista associado
          </Typography>
        </div>

        <div className='flex items-center gap-1'>
          {driverName && (
            <>
              <Typography variant='body' color='secondary' className='line-through'>
                {driverName}
              </Typography>
              <Icon name='arrow-right' />
            </>
          )}
          <Typography variant='body' color='secondary'>
            {newDriverName}
          </Typography>
        </div>
      </div>
    </>
  );
};

export default DriverConfirmationSummary;
